import * as React from "react";
import axios from 'axios';
import { EditorState,convertFromRaw,convertToRaw } from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./CardObject.css"
//import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Intent, Classes } from "@blueprintjs/core";
import { Button,ButtonGroup, Card, Elevation, Overlay,H4 } from "@blueprintjs/core";
import{HomeProps} from './Home.tsx'


import {Toaster, Position} from "@blueprintjs/core";
const toaster=Toaster.create({
  className: "my-toaster",
  position: Position.TOP_RIGHT
});


export default class CardCreationEditorForTeacher extends React.Component  <HomeProps> {
  state = {
    name: '',
    force_height:'240px',
    force_height2:'480px',
    force_width:'360px',
    parent_height:480,
    isOpenEdit:false,
    isOpenDelete:false,
    title_document_creation:'',
    description_document_creation:'',
    objectif_document_creation:'',
    typeflex:'initial',
    status_published:"eye-off",
    youtube_frame:'',
    showcontenu:'block',
    url_video:'',
    elargir:'arrow-right',
    url_video2:'',
    editorState: EditorState.createEmpty(),
    isOpenEditor:true,
    isSaveEditor:false,
    tailletexte:0,
    contenu:'',
    recordingsbydate:''
  }  
 
  
  constructor(props) {
        super(props);
        if(this.props.handleEdition!=undefined)this.props.handleEdition.bind(this);
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
   var that=this;
   this.setState({title_document_creation:this.props.title_document});
   this.setState({description_document_creation:this.props.description});
   this.setState({objectif_document_creation:this.props.objectif})
   this.setState({youtube_frame:this.props.youtube_frame});
   this.setState({url_video:this.props.url_video});
   var host=window.location.toString();
   var ll=host;
   if(ll.split('https:').length>1)host="";
   if(ll.split('http:').length>1)host="";
   
    if(this.props.type_audio =='true') {
      this.setState({force_height:'80px'}); 
      this.setState({loadthegraph:'needloaded'})
    }
    this.setState({parent_height:480})
    if(this.props.type_audio =='true') this.setState({typeflex:'100%'})
    else this.setState({typeflex:'initial'})
       
  /*  if(this.props.config =='true') {
      this.setState({force_width:'480px'});
    }*/
  }
  
  componentDidUpdate(prevProps, prevState) {
    
    if(this.state.recordingsbydate!=this.props.recordingsbydate)
    {
      console.log(this.props.recordingsbydate)
      this.setState({recordingsbydate:this.props.recordingsbydate})
      {
        this.props.recordingsbydate.map((item)=>
        {
          item.recordings.map((it)=>{
            if(it.type=="text")
            {
              console.log(it);
              if (it.data.includes(this.props.userid+"_"+this.props.id_document+".jsontext"))
              {
                console.log("a charger");
                this.loadText(it.data);
              }
            }
          })
        });
      }
    }
    
  }
  
  loadText=(url)=>
  {
   
      axios.get(url, {
        headers: {
          "Content-Type": "application/json"
        },
        responseType: "json"
      })
        .then(response => {
         
          console.log(response.data);
          const rawContent = convertFromRaw(response.data);
          this.setState({ editorState: EditorState.createWithContent(rawContent) })
        })
        .catch(err => {
          console.log("error", err);
        });
  }

  onEditorStateChange: Function = (editorState) => {
    this.setState({
      editorState,
    });    
  };
  onContentStateChange: Function = (contentState) => {
    this.setState({
      contentState,
    });
    var contentState2=this.state.editorState.getCurrentContent()
    var contenu_=JSON.stringify(convertToRaw(contentState2));//, null, 4)
    console.log(contenu_);
    if(this.state.tailletexte!=contenu_.length){this.setState({tailletexte:contenu_.length});this.setState({contenu:contenu_});this.setState({isSaveEditor:true});}
    
  };
uploadtext=async (stjson)=>
{
  const form = new FormData();
  var blob=new Blob([stjson], {type : 'application/json'});
  var objform=[];
  var date1=new Date();
  var stdate=date1.toLocaleString('fr-FR',{weekday:'long',year:'numeric',month:'long',day:'numeric',hour:'numeric',minute:'numeric',second:'numeric'});
 
  objform.push({ordre:"recordstudentdocumenttext",id_student:this.props.userid,id_matiere:this.props.id_matiere,date_record:stdate,type:"text"})
  
  form.append("uploadfile", blob, this.props.userid+"_"+this.props.timestamp+".jsontext");
  form.append("ordre", "recordstudentdocumenttext");
  form.append("id_student", this.props.userid);
  form.append("id_matiere", this.props.matiere_id);
  form.append("id_document", this.props.timestamp);
  form.append("title", this.props.title_document);
  form.append("date_record", stdate);
  form.append("type", "text");
  
     
   const response= await   fetch("/uploadstext", {
      // credentials: "include",
       method: "POST",
       body: form,
     });
     const jsons=await response.json();
     this.props.handleEditorsaved(false,jsons.filename);
     return jsons;
}
   render() {
    const { editorState } = this.state;
    const {type_audio,title_document,description,objectif,isnotdocument,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handleSelectionGetLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;
    
   
    

    return(
     <div>
  
     {/*this.props.toolbar!='true'?<Button onClick={(ev)=>
      {
        ev.preventDefault();
        this.props.handletaille();
        if(this.state.isOpenEditor==false) this.setState({isOpenEditor:true});
        else  this.setState({isOpenEditor:false});
      }}
      className={Classes.OUTLINED +" "+ Classes.LARGE} icon="edit" title="Editer" />:<div></div>*/}

     {this.state.isSaveEditor ==true?<Button onClick={(ev)=>
      {
        ev.preventDefault();
        this.setState({isSaveEditor:false});
        this.uploadtext(this.state.contenu)
      }}
      className={Classes.OUTLINED +" "+ Classes.LARGE} intent={Intent.DANGER} icon="floppy-disk" title="Sauvegarder" />:<div></div>}
     {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:true});}} className={Classes.OUTLINED+" "+ Classes.INTENT_DANGER +" " + Classes.LARGE} icon="trash" title="Effacer" />:<div></div>}
     {this.props.toolbar=='true'?<Button className={Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING} icon={this.state.status_published} title="Cours en ligne" onClick={(ev)=>{ev.preventDefault();this.handle_published();}}/>:<div></div>}
     {this.state.isOpenEditor?<div>{this.props.title_document}<br/><Editor
      editorState={editorState}
      toolbarClassName="toolbarClassName"
      wrapperClassName="wrapperClassName"
      editorClassName="editorClassName"
      toolbar={{options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker',  'history'],
        inline: { inDropdown: true },
        list: { inDropdown: true },
        textAlign: { inDropdown: false },
        history: { inDropdown: false },
      }}
      onEditorStateChange={this.onEditorStateChange}
      onContentStateChange={this.onContentStateChange}
    /></div>:null}
     </div>
    );
}
}
